import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardWidgetChartComponent } from '../../dashboard-widget-chart/dashboard-widget-chart.component';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { CommunicationService } from 'src/app/services/communication';
import { ParameterHandlerService, CacheService } from 'projects/common/src/app/services';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { IShift } from 'src/app/modules/core/interfaces';
import { groupBy, sortByKey } from 'projects/common/src/app/services/utils/utilities';
import Highcharts from 'highcharts';
import { ILoopByTrain } from 'src/app/modules/widget/interfaces/loop-by-train';
import { LoopsByTrainService } from '../../../services/loops-by-train/loops-by-train.service';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';

@Component({
  selector: 'app-loops-by-service-train',
  templateUrl: './loops-by-service-train.component.html',
  styleUrls: ['./loops-by-service-train.component.scss'],
})
export class LoopsByServiceTrainComponent extends DashboardWidgetChartComponent implements OnInit, OnDestroy {
  public shifts: any[][];
  public totalLoops: number;

  public displayMessage = false;

  constructor(
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    public loopsByTrainService: LoopsByTrainService,
    protected screenViewService: ScreenViewService,
  ) {
    super(progressBarService, communication, parameterService, sidebarService, cacheService, machineContext, screenViewService);
    this.shifts = [];
    this.totalLoops = 0;
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  protected initRequestParams(): void {
    this.params = {
      hasShift: true,
      hasCompany: true,
      hasDate: true,
    };
  }

  /**
   * Function to draw the chart
   *
   * @param chartOptions ChartOptions
   */
  public drawView(loops: ILoopByTrain[]): void {
    this.displayMessage = !loops.length;

    this.shifts = Object.values(groupBy(loops, (x: ILoopByTrain) => x.shiftName));

    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';
    const date = this.parameterService.parameters.item('date').value;
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    const user = this.parameterService.parameters.item('user-data').value;

    loops = sortByKey(loops, 'machineName');

    const totalLoops = loops.map((value) => value.loops || 0);
    this.totalLoops = totalLoops.reduce((a, b) => a + b, 0);

    const categories = this.loopsByTrainService.getCategories(loops);
    const series = this.loopsByTrainService.createSerieData(loops);
    const data = this.loopsByTrainService.getCharData(categories, series, { user, machineType, date, shift });

    this.chart = Highcharts.chart(this.chartTarget.nativeElement, data as any, (chart) => {});
  }

  /**
   * On destroy component
   */
  public onDestroy(): void {
    super.ngOnDestroy();
  }
}
